import Button from '@atlaskit/button';
import { RichTooltip } from '@atlassian/mpac-ui';
import React from 'react';
import { PopoverContentTemplate } from '../PopoverContentTemplate';
import { RichText } from '../RichText';
function getPopoverContent(content) {
  return /*#__PURE__*/React.createElement(PopoverContentTemplate, null, content.map((props, index) => /*#__PURE__*/React.createElement(RichText, {
    key: index,
    items: [props]
  })));
}
export const LinkButtonWithToolTip = props => {
  return /*#__PURE__*/React.createElement(RichTooltip, {
    content: getPopoverContent(props.content)
  }, /*#__PURE__*/React.createElement(Button, {
    appearance: "link",
    spacing: "none"
  }, props.text));
};
export default LinkButtonWithToolTip;